import { render, staticRenderFns } from "./look.vue?vue&type=template&id=32512966&scoped=true"
import script from "./look.vue?vue&type=script&lang=js"
export * from "./look.vue?vue&type=script&lang=js"
import style0 from "./look.vue?vue&type=style&index=0&id=32512966&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32512966",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32512966')) {
      api.createRecord('32512966', component.options)
    } else {
      api.reload('32512966', component.options)
    }
    module.hot.accept("./look.vue?vue&type=template&id=32512966&scoped=true", function () {
      api.rerender('32512966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ScratchJr/look.vue"
export default component.exports